// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"400ee657","453":"5a4b7e51","672":"46ac6ebb"}[chunkId] + ".chunk.js";
};